import * as React from "react";
import { AppUtils } from "source/framework/appUtils";
import { userParameterCodeShowDocumentPreview } from "source/models/common/webConsts";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType, ReportSharingType, ReportType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IListFilterItem, ListFilterItem } from "../../../models/common/listFilterItem";
import { ISavedListFilter } from "../../../models/common/savedListFilter";
import { ITypedOption } from "../../../models/common/typedOption";
import { recordLockManager } from "../../../models/services/recordLockService";
import * as riskService from "../../../models/services/riskService";
import * as userService from "../../../models/services/userService";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { HeaderMenuItem, NavigationMenu } from "../../app/NavigationMenu";
import { UserMenu } from "../../app/UserMenu";
import { ListFilterSaveDialog } from "../../framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "../../framework/Page/PageContainer";
import { PageContent } from "../../framework/Page/PageContent";
import { PageListAndReportsContainer } from "../../framework/Page/PageListAndReportsContainer";
import { PageTopBar } from "../../framework/Page/PageTopBar";
import { IPageNavMenuItem } from "../../framework/PageNav/PageNavMenuItems";
import { abortManager } from "source/models/services/tokenService";
import { RouteComponentProps } from "react-router-dom";
import { RiskStateIdFilterActive, RiskStateIdFilterArchived, RiskStateIdFilterdDraft, RiskStateIdFilterdPublished, getRiskPageGeneralFilterFromFilterState, getFilterStateFromRiskPageGeneralFilter, IRiskPageFilterState, RiskLevelNegligibleFilterdId, RiskLevelLowFilterdId, RiskLevelMediumFilterdId, RiskLevelHighFilterdId, RiskLevelCriticalFilterdId, RiskTreatmentStateInProgressFilterdId, RiskTreatmentStateCompletedFilterdId, RiskTreatmentStateLateFilterdId, RiskTreatmentStateTreatmentsSpecifiedFilterdId, RiskTypeIdRisk, RiskTypeIdOpportunity, RiskHtmlReportId, extensiveRiskReportSchema, RiskTreatmentStateNotNeededFilterdId, riskReportSchema } from "./RiskPageUtils";
import { RiskPageFilterDrawer } from "./RiskPageFilterDrawer";
import { RiskSettingsDialog, RiskSettingsDialogMenuItem } from "../RiskSettingsDialog";
import { IRiskPage } from "source/models/risk/riskPage";
import { IRiskListState, IRiskReportState, setRiskListDefaultFilter, setRiskReportDefaultFilter } from "source/models/store/risk";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { RiskList } from "../RiskList";
import { RiskTrashBinDialog } from "../RiskTrashBinDialog";
import { ICodeTitle } from "source/models/common/codeTitle";
import { IReportItem, ReportItem } from "source/models/report/reportItem";
import { getStateChangeAfterChangeActiveReport, getStateChangeAfterChangeActiveSavedReport, handleRemoveSavedReport, IReportsState, ReportItems } from "source/models/report/reportItems";
import { ISaveReportFilters, SaveReportDialog } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog";
import { PageTabs } from "source/components/framework/Page/PageTabs";
import { PageReportsContainer } from "source/components/framework/Page/PageReportsContainer";
import { ReportSettings } from "source/components/framework/ReportSettings";
import { RiskPageReportFilterDrawer } from "./RiskPageReportFilterDrawer";
import { PageNavMenuReportList } from "source/components/report/PageNavMenuItemReportList/PageNavMenuItemReportList";
import { ISavedReport } from "source/models/report/savedReport";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { RiskPageReport } from "./RiskPageReport";
import { TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

/* eslint-disable no-unused-vars */
export const enum RiskPageViewType {
    Risks = "0",
    Reports = "1"
}
/* eslint-enable no-unused-vars */

export interface IRiskPageOwnProps {
}

export interface IRiskPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    riskPage: IRiskPage;
    list: IRiskListState;
    report: IRiskReportState;
}

export interface IRiskPageDispatchProps {
    onGetRiskPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

export interface IRiskPagePathProps {
    page: string;
}

type RiskPageProp = IRiskPageOwnProps & IRiskPageStateProps & IRiskPageDispatchProps & RouteComponentProps<IRiskPagePathProps>;

interface IRiskPageState extends IRiskPageFilterState, IReportsState {
    initialized: boolean;
    listDataPreloaded: boolean;
    activeViewType: RiskPageViewType;
    riskTypes: IIdTitle[];
    units: IIdTitleNode[];
    states: IIdTitle[];
    riskCategories: IIdTitleNode[];
    riskProcesses: IIdTitleNode[];
    riskStandards: IIdTitleNode[];
    riskStakeholders: IIdTitleNode[];
    residualRisks: IIdTitle[];
    riskTreatmentStates: IIdTitle[];
    handlers: IIdTitle[];
    owners: IIdTitle[];
    activeCompanyId: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showListFilter: boolean;
    listFilterFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    canCreateRisks: boolean;
    // Settings
    showSettingsDialog: boolean;
    // Preview
    showDocumentPreview: boolean;
    // Trash Bin
    showTrashBinDialog: boolean;
    // Reports
    loadingReports: boolean;
    reportFilterReport: IReportItem;
    showReportSaveDialog: boolean;
    showReportSidePanel: boolean;
    reportSaveDialogReport: IReportItem;
    reportSaveDialogGeneralFilter: any;
    reportSaveDialogReservedNames: string[];
    reportSaveDialogOnGetReportSaveFilters: () => ISaveReportFilters;
    //...IReportsState
}

export class RiskPage extends React.Component<RiskPageProp, IRiskPageState> {
    _isMounted: boolean;

    getUnits = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(units);
    };
    
    getIdTitles = (idTitles: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(idTitles);
    };
    
    getIdTitleNodes = (items: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(items);
    };

    getStates = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(RiskStateIdFilterActive, "'" + Translations.ActivePlural + "'"));
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(RiskStateIdFilterdDraft, Translations.Draft));
        result.push(IdTitle.createIdTitle(RiskStateIdFilterdPublished, Translations.Published));
        result.push(IdTitle.createIdTitle(RiskStateIdFilterArchived, Translations.Archived));
        return result;
    };
    
    getResidualRisks = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(RiskLevelNegligibleFilterdId, Translations.RiskLevelNegligible));
        result.push(IdTitle.createIdTitle(RiskLevelLowFilterdId, Translations.RiskLevelLow));
        result.push(IdTitle.createIdTitle(RiskLevelMediumFilterdId, Translations.RiskLevelMedium));
        result.push(IdTitle.createIdTitle(RiskLevelHighFilterdId, Translations.RiskLevelHigh));
        result.push(IdTitle.createIdTitle(RiskLevelCriticalFilterdId, Translations.RiskLevelCritical));
        return result;
    };
    
    getRiskTreatmentStates = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(RiskTreatmentStateNotNeededFilterdId, Translations.RiskTreatmentStateNotNeeded));
        result.push(IdTitle.createIdTitle(RiskTreatmentStateTreatmentsSpecifiedFilterdId, Translations.RiskTreatmentStateTreatmentsSpecified));
        result.push(IdTitle.createIdTitle(RiskTreatmentStateInProgressFilterdId, Translations.RiskTreatmentStateInProgress));
        result.push(IdTitle.createIdTitle(RiskTreatmentStateCompletedFilterdId, Translations.RiskTreatmentStateCompleted));
        result.push(IdTitle.createIdTitle(RiskTreatmentStateLateFilterdId, Translations.RiskTreatmentStateLate));
        return result;
    };
    
    getHandlers = (handlers: ICodeTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(handlers.map(i => IdTitle.createIdTitle(i.code, i.title)));
    };
        
    getOwners = (owners: string[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(owners.map(i => IdTitle.createIdTitle(i, i)));
    };
        
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.RiskManagement, Translations.RiskManagement,
            {
                unitIds: [],
                stateIds: [RiskStateIdFilterActive],
            }, "modifyDate", false, 0));
        result.push(ListFilterItem.createListFilterItem(Translations.Archived, Translations.Archived,
            {
                unitIds: [],
                stateIds: [RiskStateIdFilterArchived],
            }, "modifyDate", false, 1));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getHtmlReport = (reportId: string, reportTitle: string, schema: string, generalFilter: any, sortColumn: string = "modifyDate"): IReportItem => {
        const parseResult = TaskEditTypeItem.getTaskTypeFromSchema(schema);
        const result = ReportItem.createReportItem(reportId, reportTitle, ReportType.Html,
            parseResult.taskType, generalFilter);
        result.orgTaskDataRow = parseResult.formDataRow;
        result.taskDataRow = parseResult.formDataRow;
        result.sortColumn = sortColumn;
        result.sortOrderIsAsc = false;
        return result;
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        result.push(this.getHtmlReport(
            RiskHtmlReportId.EmployeeRiskReport,
            Translations.RiskReportForEmployees,
            riskReportSchema,
            { stateIds: [RiskStateIdFilterActive] }));
        result.push(this.getHtmlReport(
            RiskHtmlReportId.ExtensiveRiskReport,
            Translations.RiskManagement,
            extensiveRiskReportSchema,
            { stateIds: [RiskStateIdFilterActive] }));
        result.push(this.getHtmlReport(
            RiskHtmlReportId.TreatmentsRiskReport,
            Translations.RiskTreatments,
            riskReportSchema,
            { stateIds: [RiskStateIdFilterActive], typeIds: [RiskTypeIdRisk] },
            "treatmentTargetDate"));
        return ReportItem.sortReportItems(result);
    };

    getListFilterIsSet = (state: IRiskPageState): boolean => {
        return RiskPageFilterDrawer.filterIsSet(state, state);
    };

    getSettingsActions = (canEditAllModuleProperties: boolean, canEditModuleProperties: boolean): IPageNavMenuItem[] => {
        const props = this.props;
        const sessionState = props.appState.state;
        const result: IPageNavMenuItem[] = [];
        if (canEditAllModuleProperties) {
            result.push({ id: RiskSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: RiskSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
        }
        if (canEditModuleProperties) {
            result.push({ id: RiskSettingsDialogMenuItem.RiskCategories, title: Translations.RiskCategories });
            result.push({ id: RiskSettingsDialogMenuItem.RiskStandards, title: Translations.RiskStandards });
            result.push({ id: RiskSettingsDialogMenuItem.RiskStakeholders, title: Translations.RiskStakeholders });
            result.push({ id: RiskSettingsDialogMenuItem.RiskProcesses, title: Translations.RiskProcesses });
            // result.push({ id: RiskSettingsDialogMenuItem.CompanyRiskTemplates, title: Translations.RiskTemplates });
        }
        if (sessionState?.isSuperAdmin) {
            result.push({ id: Translations.SystemSettings, title: Translations.SystemSettings, divider: true });
            result.push({ id: RiskSettingsDialogMenuItem.DefaultRiskCategories, title: Translations.DefaultRiskCategories });
            result.push({ id: RiskSettingsDialogMenuItem.DefaultRiskStandards, title: Translations.DefaultRiskStandards });
            result.push({ id: RiskSettingsDialogMenuItem.DefaultRiskStakeholders, title: Translations.DefaultRiskStakeholders });
            result.push({ id: RiskSettingsDialogMenuItem.DefaultRiskProcesses, title: Translations.DefaultRiskProcesses });
            result.push({ id: RiskSettingsDialogMenuItem.DefaultRiskTemplates, title: Translations.DefaultRiskTemplates });
        }
        return result;
    };

    getDefaultRiskPageListViewTypeId = (props: RiskPageProp): RiskPageViewType => {
        if (!props.match.params.page) return RiskPageViewType.Risks;
        if (props.match.params.page.equalIgnoreCase("reports")) return RiskPageViewType.Reports;
        return RiskPageViewType.Risks;
    };

    constructor(props: RiskPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, getFilterStateFromRiskPageGeneralFilter);
        const reports = this.getHtlmlReportItems();
        const activeReportId = props.report.defaultFilter?.reportId
            ? props.report.defaultFilter.reportId
            : reports[0].id;
        const state = {
            ...filterProps,
            initialized: !!props.riskPage,
            activeCompanyId: sessionState.companyId,
            activeViewType: this.getDefaultRiskPageListViewTypeId(props),
            listDataPreloaded: true,
            riskTypes: [
                IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"),
                IdTitle.createIdTitle(RiskTypeIdRisk, Translations.Risk),
                IdTitle.createIdTitle(RiskTypeIdOpportunity, Translations.Opportunity)
            ],
            units: this.getUnits(props.riskPage?.units ?? []),
            states: this.getStates(),
            riskCategories: this.getIdTitleNodes(props.riskPage?.riskCategories ?? []),
            riskProcesses: this.getIdTitleNodes(props.riskPage?.riskProcesses ?? []),
            riskStandards: this.getIdTitleNodes(props.riskPage?.riskStandards ?? []),
            riskStakeholders: this.getIdTitleNodes(props.riskPage?.riskStakeholders ?? []),
            residualRisks: this.getResidualRisks(),
            riskTreatmentStates: this.getRiskTreatmentStates(),
            handlers: this.getHandlers(props.riskPage?.handlers ?? []),
            owners: this.getOwners(props.riskPage?.owners ?? []),
            settingsActions: this.getSettingsActions(props.riskPage?.canEditAllModuleProperties ?? false, props.riskPage?.canEditModuleProperties ?? false),
            // Filters
            listFilterIsSet: false,
            activeFilterId: filters[0].id,
            activeSavedFilterId: "",
            filters,
            savedFilters: ListFilterItem.getListFilterItems(props.riskPage?.companyFilters, props.riskPage?.userFilters),
            showListFilter: false,
            listFilterFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            canCreateRisks: props.riskPage?.canCreateRisks ?? false,
            // Settings
            showSettingsDialog: false,
            // Preview
            showDocumentPreview: false,
            // Trash Bin
            showTrashBinDialog: false,
            // Reports
            loadingReports: true,
            showReportSidePanel: true,
            reports,
            savedReports: [],
            activeReportId,
            activeSavedReportId: "",
            reportChartItems: [], //Not in use
            reportFilterReport: null,
            showReportSaveDialog: false,
            reportSaveDialogReport: null,
            reportSaveDialogGeneralFilter: null,
            reportSaveDialogReservedNames: [],
            reportSaveDialogOnGetReportSaveFilters: null,
        };
        this.state = {
            ...state,
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setRiskListDefaultFilter(null);
    }

    getReports = async (companyId: string) => {
        const state = this.state;
        const newState = await ReportItems.getReportsState(companyId, state.activeReportId, state.activeSavedReportId, this.getHtlmlReportItems(), riskService.getRiskPageReportItems,
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: true });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: false });
            });
        if (!this._isMounted || !newState) return;
        this.setState({
            ...newState,
        }, () => {
            this.handleChangeActiveReport(newState.activeReportId, this.props.report.defaultFilter?.generalFilter, this.props.report.defaultFilter?.reportFilter);
            setRiskReportDefaultFilter(null);
        });
    };

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetRiskPage();
        this.getReports(null);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: RiskPageProp, prevState: IRiskPageState): void {
        const props = this.props;
        const state = this.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.riskPage?.companies.map(i => i.id) ?? [], props.riskPage?.companies.map(i => i.id) ?? []);
        const prevCompanyId = prevProps.riskPage && prevProps.riskPage.companies.length > 0
            ? prevProps.riskPage.companies[0].id
            : Base.emptyGuid;
        const companyId = props.riskPage && props.riskPage.companies.length > 0
            ? props.riskPage.companies[0].id
            : Base.emptyGuid;
        const prevCanCreateRisks = prevProps.riskPage?.canCreateRisks ?? false;
        const canCreateRisks = props.riskPage?.canCreateRisks ?? false;
        const prevCanEditModuleProperties = prevProps.riskPage?.canEditModuleProperties ?? false;
        const canEditModuleProperties = props.riskPage?.canEditModuleProperties ?? false;
        const prevCanEditAllModuleProperties = prevProps.riskPage?.canEditAllModuleProperties ?? false;
        const canEditAllModuleProperties = props.riskPage?.canEditAllModuleProperties ?? false;
        const unitsData = props.riskPage?.units ?? [];
        const equalUnits = IdTitleNode.equalIds(prevProps.riskPage?.units ?? [], unitsData);
        const units = this.getUnits(unitsData);
        const riskCategoriesData = props.riskPage?.riskCategories ?? [];
        const equalRiskCategories = IdTitleNode.equalIdsInArrays(prevProps.riskPage?.riskCategories ?? [], riskCategoriesData);
        const riskCategories = this.getIdTitleNodes(riskCategoriesData);
        const riskProcessesData = props.riskPage?.riskProcesses ?? [];
        const equalRiskProcesses = IdTitleNode.equalIdsInArrays(prevProps.riskPage?.riskProcesses ?? [], riskProcessesData);
        const riskProcesses = this.getIdTitleNodes(riskProcessesData);
        const riskStandardsData = props.riskPage?.riskStandards ?? [];
        const equalRiskStandards = IdTitleNode.equalIdsInArrays(prevProps.riskPage?.riskStandards ?? [], riskStandardsData);
        const riskStandards = this.getIdTitleNodes(riskStandardsData);
        const riskStakeholdersData = props.riskPage?.riskStakeholders ?? [];
        const equalRiskStakeholders = IdTitleNode.equalIdsInArrays(prevProps.riskPage?.riskStakeholders ?? [], riskStakeholdersData);
        const riskStakeholders = this.getIdTitleNodes(riskStakeholdersData);
        const handlersData = props.riskPage?.handlers ?? [];
        const equalHandlers = IdTitle.equal(prevProps.riskPage?.handlers ?? [], handlersData);
        const handlers = this.getHandlers(handlersData);
        const ownersData = props.riskPage?.owners ?? [];
        const equalOwners = Base.equalArrays(prevProps.riskPage?.owners ?? [], ownersData);
        const owners = this.getOwners(ownersData);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId &&
            prevCanEditAllModuleProperties === canEditAllModuleProperties &&
            prevCanEditModuleProperties === canEditModuleProperties &&
            prevCanCreateRisks === canCreateRisks && equalCompanyIds && equalUnits &&
            equalRiskCategories && equalRiskProcesses && equalRiskStandards && equalRiskStakeholders &&
            equalHandlers && equalOwners
        ) {
            return;
        }
        const savedFilters = ListFilterItem.getListFilterItems(props.riskPage?.companyFilters, props.riskPage?.userFilters);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const sessionState = props.appState.state;
        const stateChange = {
            dataId: props.dataId,
            canCreateRisks,
            initialized: !!props.riskPage,
            activeViewType: companyId !== sessionState.companyId
                ? RiskPageViewType.Risks
                : state.activeViewType,
            activeCompanyId: companyId,
            units,
            //states,
            riskCategories,
            riskProcesses,
            riskStandards,
            riskStakeholders,
            handlers,
            owners,
            selectedUnitIds,
            savedFilters,
            activeSavedFilterId,
            settingsActions: this.getSettingsActions(canEditAllModuleProperties, canEditModuleProperties),
            showDocumentPreview: props.riskPage?.showDocumentPreview ?? state.showDocumentPreview,
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null) => {
        const state = this.state;
        let result = {
            selectedRiskTypeIds: state.selectedRiskTypeIds,
            selectedUnitIds: state.selectedUnitIds,
            selectedStateIds: state.selectedStateIds,
            selectedRiskCategoryIds: state.selectedRiskCategoryIds,
            selectedRiskProcessIds: state.selectedRiskProcessIds,
            selectedRiskStandardIds: state.selectedRiskStandardIds,
            selectedRiskStakeholderIds: state.selectedRiskStakeholderIds,
            selectedResidualRiskIds: state.selectedResidualRiskIds,
            selectedRiskTreatmentStateIds: state.selectedRiskTreatmentStateIds,
            selectedHandlerUserCodes: state.selectedHandlerUserCodes,
            selectedOwners: state.selectedOwners,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, getFilterStateFromRiskPageGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId);
        this.getReports(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return {};
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState),
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return {};
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState),
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Task);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showListFilter: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            listFilterFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, getRiskPageGeneralFilterFromFilterState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Risk);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: getRiskPageGeneralFilterFromFilterState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleShowListFilter = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showListFilter: true,
            listFilterFilter: filter
        });
    };

    handleListFilterPanelOk = (closeDialog: boolean, newFilterState: IRiskPageFilterState): any => {
        const newState = {
            ...this.state,
            ...newFilterState
        };
        this.setState({
            showListFilter: !closeDialog,
            ...newFilterState,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
        return getRiskPageGeneralFilterFromFilterState(newState);
    };
    
    handleFilterPanelCancel = () => {
        this.setState({ showListFilter: false });
    };
    // #endregion Record Filter

    // #region Report
    getStateChangeAfterChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null): any => {
        return getStateChangeAfterChangeActiveReport(
            this.state,
            getFilterStateFromRiskPageGeneralFilter,
            this.getListFilterIsSet,
            activeReportId,
            additionalGeneralFilter,
            additionalReportFilter
        );
    };

    handleChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        this.setState(this.getStateChangeAfterChangeActiveReport(activeReportId, additionalGeneralFilter, additionalReportFilter));
    };

    getStateChangeAfterChangeActiveSavedReport = (activeSavedReportId: string): any => {
        return getStateChangeAfterChangeActiveSavedReport(
            this.state,
            getFilterStateFromRiskPageGeneralFilter,
            this.getListFilterIsSet,
            activeSavedReportId);
    };

    handleChangeActiveSavedReport = (activeSavedReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedReport(activeSavedReportId));
    };

    handleRemoveSavedReport = async (reportId: string) => {
        this.setState(await handleRemoveSavedReport(
            this.state,
            getFilterStateFromRiskPageGeneralFilter,
            this.getListFilterIsSet,
            ApplicationPermissionType.Risk,
            SaveReportDialog.removeReportFromDb,
            reportId
        ));
    };
    // #endregion Report

    // #region Report Filter
    getActiveReport = (): IReportItem => {
        const state = this.state;
        return state.activeReportId
            ? state.reports.find(i => i.id === state.activeReportId)
            : state.savedReports.find(i => i.id === state.activeSavedReportId);
    };

    onRecordReportFilterDialogOk = (filterState: IRiskPageFilterState, parameters: ITaskDataRow): ISaveReportFilters => {
        const state = this.state;
        const reports = state.reports.slice(0);
        const savedReports = state.savedReports.slice(0);
        const index = state.activeReportId
            ? reports.findIndex(i => i.id === state.activeReportId)
            : savedReports.findIndex(i => i.id === state.activeSavedReportId);
        if (index < 0) return;
        let reportFilter = null;
        if (state.activeReportId) {
            const report = new ReportItem(reports[index]);
            report.taskDataRow = parameters;
            reportFilter = SaveReportDialog.getReportFilter(report);
            reports[index] = report;
        } else {
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.taskDataRow = parameters;
            savedReport.reportFilter = SaveReportDialog.getReportFilter(savedReport);
            reportFilter = savedReport.reportFilter;
            savedReports[index] = savedReport;
        }
        const stateChange = {
            ...filterState,
            reports,
            savedReports,
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return {
            generalFilter: getRiskPageGeneralFilterFromFilterState(newState),
            reportFilter,
            showInFrontPage: false
        };
    };
    // #endregion Report Filter

    // #region Report Save
    handleSetSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        const state = this.state;
        if (state.activeReportId) {
            const reports = state.reports.slice(0);
            const index = reports.findIndex(i => i.id === state.activeReportId);
            if (index < 0) return;
            const report = new ReportItem(reports[index]);
            report.sortColumn = sortColumn;
            report.sortOrderIsAsc = sortOrderIsAsc;
            reports[index] = report;
            const newState = { ...this.state, reports };
            this.setState({
                reports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        } else if (state.activeSavedReportId) {
            const savedReports = state.savedReports.slice(0);
            const index = savedReports.findIndex(i => i.id === state.activeSavedReportId);
            if (index < 0) return;
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.sortColumn = sortColumn;
            savedReport.sortOrderIsAsc = sortOrderIsAsc;
            savedReports[index] = savedReport;
            const newState = { ...this.state, savedReports };
            this.setState({
                savedReports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        }
    };

    updateReportsAfterSave = (orgReportId: string, savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        if (!savedReport) return;
        const state = this.state;
        const savedReports = state.savedReports.filter(i => i.id !== orgReportId || i.reportSharingType !== reportSharingType);
        const report = state.reports.find(i => i.id === savedReport.reportId);
        if (!report) return;
        const newReport = ReportItem.createReportItemFromSavedReport(report, savedReport, reportSharingType);
        savedReports.push(newReport);
        ReportItem.sortReportItems(savedReports);
        this.setState({
            showReportSaveDialog: false,
            savedReports,
            activeReportId: "",
            activeSavedReportId: savedReport.id,
            reportFilterReport: newReport
        });
    };

    handleSaveAsReportsModifiedReport = async (saveAs: boolean, onGetReportSaveFilters: () => ISaveReportFilters) => {
        const state = this.state;
        const report = this.getActiveReport();
        if (!report) return;
        if (!saveAs) {
            const savedReport = await SaveReportDialog.saveReportToDb(report, getRiskPageGeneralFilterFromFilterState(state), state.activeCompanyId, ApplicationPermissionType.Risk);
            this.updateReportsAfterSave(report.id, savedReport, report.reportSharingType);
        } else {
            this.setState({
                showReportSaveDialog: true,
                reportSaveDialogReport: report,
                reportSaveDialogReservedNames: state.savedReports.map(i => i.id).concat(state.reports.map(i => i.title)),
                reportSaveDialogGeneralFilter: getRiskPageGeneralFilterFromFilterState(state),
                reportSaveDialogOnGetReportSaveFilters: onGetReportSaveFilters
            });
        }
    };

    handleReportSaveDialogOk = (savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        this.updateReportsAfterSave("", savedReport, reportSharingType);
    };

    handleReportSaveDialogCancel = () => {
        this.setState({
            showReportSaveDialog: false
        });
    };
    // #endregion Report Save
    
    // #region Units
    handleRefreshPageData = async (companyId: string) => {
        const pageData = await riskService.getRiskPageData(companyId);
        if (!pageData) return;
        //Units
        const units = this.getUnits(pageData.units);
        const selectedUnitIds = IdTitleNode.keepAvailableSelectedIds(units, this.state.selectedUnitIds);
        //RiskCategories
        const riskCategories = this.getIdTitleNodes(pageData.riskCategories);
        const selectedRiskCategoryIds = IdTitleNode.keepAvailableSelectedIds(riskCategories, this.state.selectedRiskCategoryIds);
        //RiskProcesses
        const riskProcesses = this.getIdTitleNodes(pageData.riskProcesses);
        const selectedRiskProcessIds = IdTitleNode.keepAvailableSelectedIds(riskProcesses, this.state.selectedRiskProcessIds);
        //RiskStandards
        const riskStandards = this.getIdTitleNodes(pageData.riskStandards);
        const selectedRiskStandardIds = IdTitleNode.keepAvailableSelectedIds(riskStandards, this.state.selectedRiskStandardIds);
        //RiskStakeholders
        const riskStakeholders = this.getIdTitleNodes(pageData.riskStakeholders);
        const selectedRiskStakeholderIds = IdTitleNode.keepAvailableSelectedIds(riskStakeholders, this.state.selectedRiskStakeholderIds);
        //Handlers
        const handlers = this.getHandlers(pageData.handlers);
        const selectedHandlerUserCodes = Base.keepAvailableSelectedIds(handlers, this.state.selectedHandlerUserCodes, "");
        //Owners
        const owners = this.getOwners(pageData.owners);
        const selectedOwners = Base.keepAvailableSelectedIds(owners, this.state.selectedOwners, "");
        const stateChange = {
            activeCompanyId: companyId,
            units,
            riskCategories,
            riskProcesses,
            riskStandards,
            riskStakeholders,
            handlers,
            owners,
            selectedUnitIds,
            selectedRiskCategoryIds,
            selectedRiskProcessIds,
            selectedRiskStandardIds,
            selectedRiskStakeholderIds,
            selectedHandlerUserCodes,
            selectedOwners,
            canCreateRisks: pageData.canCreateRisks,
            settingsActions: this.getSettingsActions(pageData.canEditAllModuleProperties, pageData.canEditModuleProperties),
        };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet({ ...this.state, ...stateChange }),
        });
    };
    // #endregion Units

    handleShowDetailsPanel = (showDocumentPreview) => {
        this.setState({ showDocumentPreview });
        AppUtils.callService(() => userService.saveUserParameter(userParameterCodeShowDocumentPreview, showDocumentPreview ? "TRUE" : "FALSE"), false, true);
    };
        
    // #region ViewType
    setActiveViewType = (activeViewType: RiskPageViewType, activeFilterId: string = null, additionalGeneralFilter: any = null) => {
        const state = this.state;
        //To reset filter when filter/report is activated
        let newState = {};
        if (activeViewType === RiskPageViewType.Reports) {
            if (state.activeReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(state.activeReportId);
            } else if (state.activeSavedReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(state.activeSavedReportId);
            }
        } else if (activeViewType === RiskPageViewType.Risks) {
            if (activeFilterId ?? state.activeFilterId) {
                newState = this.getStateChangeAfterChangeActiveFilter(activeFilterId ?? state.activeFilterId, additionalGeneralFilter);
            } else if (state.activeSavedFilterId) {
                newState = this.getStateChangeAfterChangeActiveSavedFilter(state.activeSavedFilterId);
            }
        }
        this.setState({
            ...newState,
            activeViewType
        });
    };

    handleSetActiveViewType = (activeViewType: RiskPageViewType, activeFilterId: string = null, additionalGeneralFilter: any = null) => {
        this.setActiveViewType(activeViewType, activeFilterId, additionalGeneralFilter);
    };
    // #endregion ViewType

    // #region Settings
    handleOpenSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };
    
    handleSettingsDialogOk = async () => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        await this.handleRefreshPageData(this.state.activeCompanyId);
    };
    // #endregion Settings

    // #region Transh bin dialog
    handleOpenTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: true
        });
    };
    
    handleCloseTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: false,
            dataId: this.state.dataId + 1
        });
    };
    // #endregion Transh bin dialog

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.riskPage ? props.riskPage.companies : [];
        const risksViewIsActive = state.activeViewType === RiskPageViewType.Risks;
        const reportsViewIsActive = state.activeViewType === RiskPageViewType.Reports;
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.Risks}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar justifyContent="space-between">
                        <PageTabs
                            activeTabId={state.activeViewType}
                            tabs={[
                                { id: RiskPageViewType.Risks, title: Translations.RiskManagement },
                                { id: RiskPageViewType.Reports, title: Translations.Reports }
                            ]}
                            changeTab={this.handleSetActiveViewType}
                        />
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    <PageListAndReportsContainer>
                        {risksViewIsActive &&
                            <RiskList
                                filterName={state.activeSavedFilterId
                                    ? state.savedFilters.find(i => i.id === state.activeSavedFilterId)?.title
                                    : state.activeFilterId && state.activeFilterId !== Translations.RiskManagement
                                        ? state.filters.find(i => i.id === state.activeFilterId)?.title
                                        : null}
                                sessionState={sessionState}
                                dataId={state.dataId.toString(10)}
                                canCreateRisks={state.canCreateRisks}
                                listFilterIsSet={state.listFilterIsSet}
                                units={state.units}
                                selectedRiskTypeIds={state.selectedRiskTypeIds}
                                selectedUnitIds={state.selectedUnitIds}
                                selectedStateIds={state.selectedStateIds}
                                selectedRiskCategoryIds={state.selectedRiskCategoryIds}
                                selectedRiskProcessIds={state.selectedRiskProcessIds}
                                selectedRiskStandardIds={state.selectedRiskStandardIds}
                                selectedRiskStakeholderIds={state.selectedRiskStakeholderIds}
                                selectedResidualRiskIds={state.selectedResidualRiskIds}
                                selectedRiskTreatmentStateIds={state.selectedRiskTreatmentStateIds}
                                selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                selectedOwners={state.selectedOwners}
                                companyId={state.activeCompanyId}
                                sortColumn={state.sortColumn}
                                sortOrderIsAsc={state.sortOrderIsAsc}
                                settingsActions={state.settingsActions}
                                trashBin={false}
                                showDocumentPreview={state.showDocumentPreview}
                                onOpenFiltersDialog={this.handleShowListFilter}
                                onSetSortData={this.handleFilterSortData}
                                onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                                onOpenTrashBinDialog={this.handleOpenTrashBinDialog}
                                onChangeShowDocumentPreview={this.handleShowDetailsPanel}
                                onToggleSettingsDialog={this.handleOpenSettingsDialog}
                                reportTabs={(
                                    <FilterTabs
                                        items={state.savedFilters}
                                        standardFilters={state.filters}
                                        selectedId={this.state.activeFilterId}
                                        selectedSavedId={this.state.activeSavedFilterId}
                                        onSetActiveItem={this.handleChangeActiveSavedFilter}
                                        onSetActiveStandardItem={this.handleChangeActiveFilter}
                                    />
                                )}
                            />
                        }
                        {reportsViewIsActive &&
                            <PageReportsContainer>
                                <RiskPageReport
                                    sessionState={sessionState}
                                    companyId={state.activeCompanyId}
                                    reports={state.activeReportId ? state.reports : state.savedReports}
                                    reportId={state.activeReportId ? state.activeReportId : state.activeSavedReportId}
                                    riskTypes={state.riskTypes}
                                    units={state.units}
                                    states={state.states}
                                    riskCategories={state.riskCategories}
                                    riskProcesses={state.riskProcesses}
                                    riskStandards={state.riskStandards}
                                    riskStakeholders={state.riskStakeholders}
                                    residualRisks={state.residualRisks}
                                    riskTreatmentStates={state.riskTreatmentStates}
                                    handlers={state.handlers}
                                    owners={state.owners}
                                    selectedRiskTypeIds={state.selectedRiskTypeIds}
                                    selectedUnitIds={state.selectedUnitIds}
                                    selectedStateIds={state.selectedStateIds}
                                    selectedRiskCategoryIds={state.selectedRiskCategoryIds}
                                    selectedRiskProcessIds={state.selectedRiskProcessIds}
                                    selectedRiskStandardIds={state.selectedRiskStandardIds}
                                    selectedRiskStakeholderIds={state.selectedRiskStakeholderIds}
                                    selectedResidualRiskIds={state.selectedResidualRiskIds}
                                    selectedRiskTreatmentStateIds={state.selectedRiskTreatmentStateIds}
                                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                    selectedOwners={state.selectedOwners}
                                    showSidePanel={state.showReportSidePanel}
                                    onChangeShowSidePanel={showReportSidePanel => this.setState({ showReportSidePanel })}
                                    onSetSortData={this.handleSetSortData}
                                />
                                {state.showReportSidePanel &&
                                    <ReportSettings
                                        filters={
                                            <RiskPageReportFilterDrawer
                                                companyId={state.activeCompanyId}
                                                report={state.reportFilterReport}
                                                riskTypes={state.riskTypes}
                                                units={state.units}
                                                states={state.states}
                                                riskCategories={state.riskCategories}
                                                riskProcesses={state.riskProcesses}
                                                riskStandards={state.riskStandards}
                                                riskStakeholders={state.riskStakeholders}
                                                residualRisks={state.residualRisks}
                                                riskTreatmentStates={state.riskTreatmentStates}
                                                handlers={state.handlers}
                                                owners={state.owners}
                                                selectedRiskTypeIds={state.selectedRiskTypeIds}
                                                selectedUnitIds={state.selectedUnitIds}
                                                selectedStateIds={state.selectedStateIds}
                                                selectedRiskCategoryIds={state.selectedRiskCategoryIds}
                                                selectedRiskProcessIds={state.selectedRiskProcessIds}
                                                selectedRiskStandardIds={state.selectedRiskStandardIds}
                                                selectedRiskStakeholderIds={state.selectedRiskStakeholderIds}
                                                selectedResidualRiskIds={state.selectedResidualRiskIds}
                                                selectedRiskTreatmentStateIds={state.selectedRiskTreatmentStateIds}
                                                selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                                selectedOwners={state.selectedOwners}
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                onSaveReport={this.handleSaveAsReportsModifiedReport}
                                                onRemoveReport={this.handleRemoveSavedReport}
                                                onOk={this.onRecordReportFilterDialogOk}
                                            />
                                        }
                                        reports={
                                            <PageNavMenuReportList
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                items={state.savedReports}
                                                standardReports={state.reports}
                                                activeItemId={state.activeSavedReportId}
                                                activeStandardItemId={state.activeReportId}
                                                showingSavedReports={true}
                                                title={Translations.Report}
                                                onSetActiveItem={this.handleChangeActiveSavedReport}
                                                onSetActiveStandardItem={this.handleChangeActiveReport}
                                            />
                                        }
                                    />
                                }
                            </PageReportsContainer>
                        }
                    </PageListAndReportsContainer>
                </PageContent>
                <RiskPageFilterDrawer
                    companyId={state.activeCompanyId}
                    open={state.showListFilter}
                    filter={state.listFilterFilter}
                    riskTypes={state.riskTypes}
                    units={state.units}
                    states={state.states}
                    riskCategories={state.riskCategories}
                    riskProcesses={state.riskProcesses}
                    riskStandards={state.riskStandards}
                    riskStakeholders={state.riskStakeholders}
                    residualRisks={state.residualRisks}
                    riskTreatmentStates={state.riskTreatmentStates}
                    handlers={state.handlers}
                    owners={state.owners}
                    selectedRiskTypeIds={state.selectedRiskTypeIds}
                    selectedUnitIds={state.selectedUnitIds}
                    selectedStateIds={state.selectedStateIds}
                    selectedRiskCategoryIds={state.selectedRiskCategoryIds}
                    selectedRiskProcessIds={state.selectedRiskProcessIds}
                    selectedRiskStandardIds={state.selectedRiskStandardIds}
                    selectedRiskStakeholderIds={state.selectedRiskStakeholderIds}
                    selectedResidualRiskIds={state.selectedResidualRiskIds}
                    selectedRiskTreatmentStateIds={state.selectedRiskTreatmentStateIds}
                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                    selectedOwners={state.selectedOwners}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.handleListFilterPanelOk}
                    onCancel={this.handleFilterPanelCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Risk}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showReportSaveDialog &&
                    <SaveReportDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Risk}
                        report={state.reportSaveDialogReport}
                        generalFilter={state.reportSaveDialogGeneralFilter}
                        reservedNames={state.reportSaveDialogReservedNames}
                        onGetReportSaveFilters={state.reportSaveDialogOnGetReportSaveFilters}
                        onOk={this.handleReportSaveDialogOk}
                        onCancel={this.handleReportSaveDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <RiskSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
                {state.showTrashBinDialog &&
                    <RiskTrashBinDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        units={state.units}
                        onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                        onClose={this.handleCloseTrashBinDialog}
                    />
                }
            </PageContainer>
        );
    }
}